export const USER_AUTHENTICATED = 'auth_user';
export const CURRENT_USER_FETCHED = 'current_user_fetched';
export const USER_UNAUTHENTICATED = 'unauth_user';
export const AUTH_ERROR = 'auth_error';
export const CLEAR_AUTH_ERROR = 'clear_auth_error';
export const CHECK_LOGIN_AVAILABLE = 'check_login_available';
export const CHECK_EMAIL_AVAILABLE = 'check_email_available';
export const UPDATE_PROFILE = 'update_profile';
export const CHANGE_PASSWORD = 'change_password';
export const RESET_SCOPEDROLES = 'reset_scopedroles';
export const GET_SCOPEDROLES = 'get_scopedroles';
export const USER_SIGN_VALIDATION = 'user_sign_validation';
export const TRAINING_NOTIFICATION = 'training_notification';
export const SET_CAPTCHA_INVISIBLE = 'set_captcha_invisible';
export const SET_CAPTCHA_NORMAL = 'set_captcha_normal';
export const SET_MSAL_INSTANCE = 'set_msal_instance';
export const SET_SSO_AUTHENTICATED = 'set_sso_authenticated';
export const SET_MFA_TOKEN_TYPE = 'set_mfa_token_type';

export interface UserStatus {
  name: string,
  id: number
}
